module.exports = __webpack_public_path__ + "static/media/SVGFirstPost.734e68e5.svg";